import { render } from "./DashboardTemplateScoresExplorer.vue?vue&type=template&id=0dd3413e"
import script from "./DashboardTemplateScoresExplorer.vue?vue&type=script&lang=js"
export * from "./DashboardTemplateScoresExplorer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__